module.exports = "<p>\n  customers works!\n</p>\n"